import _ from "lodash";

import Marker from "app/core/entities/map/marker/Marker";

class DeliveryPointMarker extends Marker {
    /**
     * @public
     * @method hasSelfDelivery
     * @returns {boolean}
     */
    hasSelfDelivery() {
        // Фикс для новой почты
        if (this.entity.iconUrl === "https://i.apteka24.ua/icons/IconNewPost.png") {
            return false;
        }

        return Boolean(this.entity.selfService);
    }

    /**
     * @public
     * @method setAddressAsText
     * @param value {string}
     * @returns {Marker}
     */
    setSelfDelivery(value) {
        this.entity.selfService = Boolean(value);

        return this;
    }

    /**
     * @public
     * @method getPhone
     * @returns {string}
     */
    getPhone() {
        return this.entity.phone || "";
    }

    /**
     * @public
     * @method setPhone
     * @param value {string}
     * @returns {DeliveryPointMarker}
     */
    setPhone(value) {
        if (_.isString(value)) {
            this.entity.phone = value;
        }

        return this;
    }

    /**
     * @public
     * @method getDeliveryMethodType
     * @returns {*|int}
     */
    getDeliveryMethodType() {
        return this.entity.deliveryMethodType || null;
    }

    /**
     * @public
     * @method setDeliveryMethodType
     * @param value
     * @returns {DeliveryPointMarker}
     */
    setDeliveryMethodType(value) {
        this.entity.deliveryMethodType = value;

        return this;
    }

    /**
     * @public
     * @method getWorkTime
     * @returns {string}
     */
    getWorkTime() {
        return this.entity.workTime || "";
    }

    /**
     * @public
     * @method setWorkTime
     * @param value {string}
     * @returns {DeliveryPointMarker}
     */
    setWorkTime(value) {
        if (_.isString(value)) {
            this.entity.workTime = value;
        }

        return this;
    }

    /**
     * @public
     * @method getTypeSlug
     * @returns {string}
     */
    getTypeSlug() {
        return this.entity.typeSlug || "";
    }

    /**
     * @public
     * @method getVendorId
     * @returns {string}
     */
    getVendorId() {
        return this.entity.vendor_id || "";
    }

    /**
     * @public
     * @method setVendorId
     * @returns {string}
     */
    setVendorId(value) {
        if (_.isString(value)) {
            this.entity.vendor_id = value;
        }

        return this;
    }

    /**
     * @public
     * @method setTypeSlug
     * @param value
     * @returns {DeliveryPointMarker}
     */
    setTypeSlug(value) {
        if (_.isString(value)) {
            this.entity.typeSlug = value;
        }

        return this;
    }

    /**
     * @method getSiteUrl
     * @returns {string}
     */
    getSiteUrl() {
        return this.entity.siteUrl || "";
    }

    /**
     * @method getLicenseAsHTML
     * @returns {string}
     */
    getLicenseAsHTML() {
        return this.entity.license || "";
    }

    /**
     * @public
     * @method getUrl
     * @returns {string}
     */
    getUrl() {
        return this.entity.url || "";
    }

    /**
     * @public
     * @method setIconUrl
     * @param url {string}
     * @return {DeliveryPointMarker}
     */
    setIconUrl(url) {
        if (_.isString(url)) {
            this.entity.iconUrl = url;
        }

        return this;
    }

    /**
     * @public
     * @method getIconUrl
     * @return {string}
     */
    getIconUrl() {
        return this.entity.iconUrl || "";
    }
}

export default DeliveryPointMarker;
